
define(
	'jsx!components/viewbuncee',[
		"react",
		"actions/viewbuncee",
		"stores/viewbuncee",
		"jsx!components/modal/duplicate-buncee",
		"jsx!components/modal/share",
		"jsx!components/modal/export",
		"jsx!components/modal/login",
		"shared/user",
	], function (React,ViewBunceeActions, ViewBunceeStore, DuplicateBunceeModal, ShareModal, DownloadModal, LoginModal, User) {
		return React.createClass({
			actions : new ViewBunceeActions(),
			getInitialState: function ()
			{
				var clip = false;
				var comment = false;
				// debugger;
				if(appData.user && sessionStorage.getItem("panelAfterLogin")) {
					switch(sessionStorage.getItem("panelAfterLogin")) {
						case "clip":
							clip = true;
							break;
						case "comment":
							comment = true;
					}

					sessionStorage.removeItem("panelAfterLogin");
				}
				

				return {
					hasCitations : false,
					comment: comment,
					info: false,
					tags: false,
					tagError: false,
					clip: clip,
					selectedToClip: null,
					postingClips: false,
					orientation: window.innerHeight > window.innerWidth ? 'portrait' : 'landscape'
				}
			},
			componentWillMount: function ()
			{
				document.addEventListener("keyup", this.handleKeyUp);
				var screen_change_events = "webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange";
				var self = this;

				$(document).on(screen_change_events, this.handleFullScreenMode);

				this.stores = {
					buncee: new ViewBunceeStore()
				};
				this.stores.buncee.addChangeListener(this.handleChangeFromBunceeStore);
				this.actions.pullComments(window.appData.buncee.data.guid);
				if(window.appData.user) {
					this.actions.pullLikeState(window.appData.buncee.data.guid);	
					this.actions.pullLikes(window.appData.buncee.data.guid);
				}
				window.appData.local = {};
				$(window).resize(function() {
					if(window.innerHeight > window.innerWidth && self.state.orientation !== 'portrait') {
						self.setState({
							orientation: 'portrait'
						});
					} 
					else if(window.innerHeight < window.innerWidth && self.state.orientation !== 'landscape') {
						self.setState({
							orientation: 'landscape'
						});
					}
				});
			},
			handleFullScreenMode: function() {
				if(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement) {
					olark("api.box.hide");
				}
				else {
					olark("api.box.show");
				}

				this.forceUpdate();
			},
			handleChangeFromBunceeStore: function()
			{
				this.forceUpdate();
			},
			closeBuncee: function() {
				window.open('#','_self').close();
				this.gotoBuncees();
			},
			gotoBuncees : function() {
				if(window.appData.user && window.appData.user.access_token) {
					window.location = "/dashboard#buncees";
				} else {
					window.location = "/";
				}
			},
			hasPermission: function(type) {
				return User.hasPermission(type);
			},
			handleClickOnShare : function() {
				//debugger;
				var shareModal = React.createElement(ShareModal, {
					stores : this.stores
				});
				React.render(shareModal,document.getElementById('buncee-modal'));
			},
			handleClickOnDownload : function() {
				var downloadModal = React.createElement(DownloadModal, {
					stores : this.stores
				});
				React.render(downloadModal,document.getElementById('buncee-modal'));
			},
			handleClickOnEdit : function() {
				window.location.href = window.appData.buncee.links.edit;
			},
			handleClickOnCopy: function () {
				var modal = React.createElement(DuplicateBunceeModal, {
					buncee_guid: window.appData.buncee.data.guid
				});
				React.render(modal, document.getElementById('buncee-modal'));
			},
			openLogin : function() {
				var modal = React.createElement(LoginModal);
				React.render(modal,document.getElementById('buncee-modal'));
			},
			toggleToClip: function(e) {
				var idx = $(e.currentTarget).parent().index();
				var state = "clip";


				if(!this.state.selectedToClip) {
					this.setState({selectedToClip: {
						state: state,
						slides: [idx]
					}});
				}
				else {
					if(_.filter(this.state.selectedToClip.slides, function(order){ return order == idx; }).length > 0) {
						var slides = _.filter(this.state.selectedToClip.slides, function(order){ return order != idx; });
						if(slides.length > 0) {
							this.setState({selectedToClip: {
								state: this.state.selectedToClip.state,
								slides: slides
							}});
						}
						else {
							this.setState({selectedToClip: null});
						}

						return;
					}

					var slides = this.state.selectedToClip.state == state ? this.state.selectedToClip.slides : [];
					
					slides.push(idx);
					this.setState({selectedToClip: {
						state: state,
						slides: slides
					}});
				}
			},
			selectAllToClip: function(e) {
				
				var self = this;
				var slides = [];

				_.each(appData.buncee.data.slides, function(slide) {
					slides.push(slide.order);
				});

				this.setState({selectedToClip: {state: "clip", slides: slides}});
				
			},
			deselectAllToClip: function(e) {
				this.setState({selectedToClip: null});	
			},
			postClips: function() {
				var self = this;
				
				if(this.state.selectedToClip.state == "unclip")
					return;
				var slides = [];
				_.each(this.state.selectedToClip.slides, function(idx) {
					slides.push(JSON.stringify({slide_original_order : idx, obj: appData.buncee.data.slides[idx]}));
				});

				self.setState({postingClips: true});
				
				this.actions.postClips(slides, function() {
					self.setState({postingClips: false});
					self.deselectAllToClip();
					self.forceUpdate();
					self.actions.toast("#clip-view", "Clipped Successfully.");
					console.log("Clipped Successfully.");
				}, function() {
					self.setState({postingClips: false});
					self.deselectAllToClip();
					self.forceUpdate();
					self.actions.toast("#clip-view", "Try after the thumbnail was generated.");
					console.log("Try after the thumbnail was generated.");
				});
			},
			componentDidMount: function ()
			{
				_.each($('[data-toggle="tooltip"]'), function(element) {
					var tip = $("<div class='viewbuncee-tooltip'>"+$(element).attr("title")+"</div>");
					$(element).append(tip);
				});

				if (document.getElementById('info-container').offsetHeight > 45) {
					$('#info-container').css('top', '0');
				}
				if ($('iframe').length > 0) {
					$('#buncee-view').on('load', function() {
						var frame = $('iframe')[0];
						var cWindow = frame.contentWindow || frame.contentDocument;
						cWindow.focus();
					});
				}
				if (window.location.href.indexOf("#comment") > 0) {
					this.toggleComment();
				} else if (window.location.href.indexOf("#email") > 0) {
					this.showShare();
				} else if (window.location.href.indexOf("#rsvp") > 0) {
					this.showShare();
				}

				//var hasCitation = !this.stores.buncee.getBuncee().slides.every(function(slide){
				//	if(slide.background.attributes && slide.background.attributes.source_url) {
				//		return false;
				//	}
				//	return slide.items.every(function(item){
				//		return !(item.content.attributes && item.content.attributes.source_url);
				//	});
				//});

				$('.mobile-dropdown-menu-button').click(function(){
					$(this).toggleClass('open');
					$(".mobile-dropdown-menu").toggleClass('open');
				});

				this.setState({
					hasCitations : true
				})
			},
			getUrlParameter : function(sParam) {
				var sPageURL = decodeURIComponent(window.location.search.substring(1)),
					sURLVariables = sPageURL.split('&'),
					sParameterName,
					i;

				for (i = 0; i < sURLVariables.length; i++) {
					sParameterName = sURLVariables[i].split('=');

					if (sParameterName[0] === sParam) {
						return sParameterName[1] === undefined ? true : sParameterName[1];
					}
				}
			},
			toggleComment: function() {
				var self = this;

				if(this.state.info){
					this.toggleInfo();
				}
				if(this.state.tags) {
					this.toggleTags();
				}

				if(this.state.clip) {
					this.toggleClip();
				}

				if(this.state.comment) {
					$('#comment-view').animate({
						'right': '-300px'
					}, 200, function() {
						self.setState({'comment': false});
						$('#comment-view').hide();
					});
				}
				else {
					if(appData.user) {
						$('#comment-view').show();
						$('#comment-view').animate({
							'right': '0'
						}, 200, function() {
							self.setState({'comment': true});
						});
					}
					else {
						sessionStorage.setItem("panelAfterLogin", "comment");
						this.openLogin();
					}
				}
			},
			toggleTags: function() {
				var self = this;

				if(this.state.comment){
					this.toggleComment();
				}
				if(this.state.info){
					this.toggleInfo();
				}

				if(this.state.clip) {
					this.toggleClip();
				}

				if(this.state.tags) {
					$('#tag-view').animate({
						'right': '-300px'
					}, 200, function() {
						self.setState({'tags': false});
						$('#tag-view').hide();
					});
				}
				else {
					$('#tag-view').show();
					$('#tag-view').animate({
						'right': '0'
					}, 200, function() {
						self.setState({'tags': true});
					});
				}
			},
			toggleInfo : function() {
				var self = this;

				if(this.state.comment){
					this.toggleComment();
				}

				if(this.state.tags) {
					this.toggleTags();
				}

				if(this.state.clip) {
					this.toggleClip();
				}

				if(this.state.info) {
					$('#info-view').animate({
						'right': '-300px'
					}, 200, function() {
						self.setState({'info': false});
						$('#comment-view').hide();
					});
				}
				else {
					$('#info-view').show();
					$('#info-view').animate({
						'right': '0'
					}, 200, function() {
						self.setState({'info': true});
					});
				}
			},
			toggleClip : function(e) {
				var self = this;

				if(this.state.comment){
					this.toggleComment();
				}

				if(this.state.tags) {
					this.toggleTags();
				}

				if(this.state.info) {
					this.toggleInfo();
				}

				if(this.state.clip) {
					$('#clip-view').animate({
						'right': '-300px'
					}, 200, function() {
						self.setState({'clip': false});
					});
				}
				else {
					if(appData.user) {
						$('#clip-view').show();
						$('#clip-view').animate({
							'right': '0'
						}, 200, function() {
							self.setState({'clip': true});
						});
						this.closeHelpcenter(e);
					}
					else {
						sessionStorage.setItem("panelAfterLogin", "clip");
						this.openLogin();
					}	
				}
			},
			handleCommentEditorKeyPress: function(e){
				e = e.nativeEvent;
				if(e.keyCode === 13) {
					this.actions.postComment(window.appData.buncee.data.guid, e.target.value);
					e.target.value = "";
				}
			},
			postComment: function(e){
				this.actions.postComment(window.appData.buncee.data.guid, document.getElementById('input-comment').value);
				document.getElementById('input-comment').value = "";
			},
			deleteComment: function(e) {
				var guid = e.target.getAttribute('data-guid');
				this.actions.deleteComment(window.appData.buncee.data.guid, guid);
			},
			handleKeyPressTag: function(e){
				//console.log(e);
				if(this.state.tagError) {
					this.setState({
						'tagError' : false
					});
				}
				if(e.keyCode === 13 || e.keyCode === 44) {
					if(window.appData.local.selectedTag > -1) {
						React.findDOMNode(this.refs.tagInput).value = window.appData.local.suggestedTags[window.appData.local.selectedTag].data.tag;
						window.appData.local.selectedTag = -1;
						this.clearTagSuggestions();
					}
					else {
						var tagValue = React.findDOMNode(this.refs.tagInput).value;
						var newValue = tagValue.replace(/[\x00-\x2F\x3A-\x40\x5B-\x60\x7B-\xBF\xD7\xF7]/gi, "");
						if (newValue.length > 2 && newValue.length < 255) {
							this.actions.createTags(window.appData.buncee.data.guid,[newValue]);
							React.findDOMNode(this.refs.tagInput).value = "";
						}

						e.preventDefault();
						if (React.findDOMNode(this.refs.tagInput).value != "") {
							this.setState({
								'tagError': true
							})
						}
						this.clearTagSuggestions();
					}
				} else if(e.keyCode == 40) {
					//console.log("down pressed");
					var suggestedTags = window.appData.local.suggestedTags;
					if(suggestedTags) {
						//console.log("tags exist");
						if(typeof window.appData.local.selectedTag == "undefined") {
							//console.log("initselected");
							window.appData.local.selectedTag = -1;
						}
						//console.log(suggestedTags,suggestedTags.tags.length);
						if(window.appData.local.selectedTag < suggestedTags.length-1) {
							//console.log("increment");
							window.appData.local.selectedTag++;
							this.forceUpdate();
						}
					}
				} else if(e.keyCode == 38) {
					//console.log("Up pressed");
					if(typeof window.appData.local.selectedTag == "undefined") {
						window.appData.local.selectedTag = -1;
					}
					if(window.appData.local.selectedTag > 0) {
						window.appData.local.selectedTag--;
						this.forceUpdate();
					}
				} else {
					this.getTagSuggestions(e.target);
				}

			},
			getTagSuggestions : function(target) {
				var self = this;
				if(window.appData.local.suggestedTags) {
					window.appData.local.suggestedTags = null;
					this.forceUpdate();
				}
				if(target.value && target.value.length > 2) {
					//console.log(tagValue);
					this.actions.getTagSuggestions(target, function() {
						self.forceUpdate();
					});
				}

			},
			clearTagSuggestions : function(e) {
				if(window.appData.local.suggestedTags) {
					window.appData.local.suggestedTags = null;
					window.appData.local.selectedTag = -1;
					this.forceUpdate();
				}
			},
			postTag : function(e) {
				this.handleKeyPressTag({
					keyCode : 13,
					preventDefault : function(){}
				});
			},
			removeTag : function(e) {
				var self = e.target;
				while(self && !self.attributes['data-tagid'])
					self = self.parentElement;
				var tagGuid = self.attributes['data-tagid'].value;
				this.actions.removeTag(window.appData.buncee.data.guid, tagGuid);
			},
			likeBuncee : function(e) {
				this.actions.toggleLikeState(window.appData.buncee.data.guid);
			},
			closeHelpcenter: function(e) {
				e.preventDefault();
				$('#helpcenter').remove();
			},
			render: function ()
			{
				console.log(this.state.orientation);
				var self = this;
				var tags = this.stores.buncee.getTags();
				var assignmentButton;
				var submissionButton;
				var columnLeft = {
					'paddingLeft': 0,
					'paddingRight': 0,
					'textAlign': 'left'
				};
				var columnRight = {
					'paddingLeft': 0,
					'paddingRight': 0,
					'textAlign': 'right',
					'position': 'relative'
				};
				var columnNoPadding = {
					'padding': 0
				};

				var styleEdit = {
					'display': 'inline-block',
					'marginLeft': '10px',
					'marginTop': '6px'
				};

				var styleSetting = {
					'display': 'inline-block',
					'marginLeft': '10px',
					'marginRight': '10px',
					'marginTop': '6px'
				};

				var styleB = {
					'display': 'inline-block',
					'marginLeft': '10px',
					'marginTop': '6px',
				};

				var styleExport = {
					'display': 'inline-block',
					'marginRight': '10px',
					'marginTop': '6px'
				};

				var styleShare = {
					'display': 'inline-block',
					'marginRight': '10px',
					'marginTop': '6px'
				};

				var styleInfo = {
					'display': 'inline-block',
					'marginRight': '10px',
					'marginTop': '6px'
				};

				var styleTitle = {
					'fontSize': '20px',
					'textAlign': 'center',
					'fontFamily': 'Lato',
					'height': 'auto',
					'border': 0,
					'outline': 0,
					'width': '100%',
					'fontWeight': 'normal',
					'letterSpacing': '-1px',
					'color': '#5A5A5A',
					'position': 'relative',
					'top': '10px',
					'marginLeft': 'auto',
					'marginRight': 'auto',
					'background': 'white'
				};

				var alignRight = {
					'display': 'inline-block',
					'marginRight': '10px',
					'marginTop': '6px'
				};

				var styleCommentView = this.state.comment ? { 'right': '0', 'display':'block'} : {	'right': '-300px', 'display':'none' };
				var styleInfoView = this.state.info ? { 'right': '0', 'display':'block'} : {	'right': '-300px', 'display':'none' };
				var styleTagView = this.state.tags ? { 'right': '0', 'display':'block'} : {	'right': '-300px', 'display':'none' };
				var styleClipView = this.state.clip ? { 'right': '0', 'display':'block'} : {	'right': '-300px', 'display':'none' };
				var styleComment = {
					'background': "url('https://cdn.edu.buncee.com/rackspace/avatars/user_default.png')",
					'backgroundSize': '30px'
				};

				var colorLike = {
					'color': '#C21111'
				};

				var colorComment = {
					'color': '#178FA5'
				};

				var colorClip = {
					'color': '#795548'
				};

				var colorReport = {
					'color': '#1C2C71'
				};

				var colorInfo = {
					'color': '#5F6064'
				};

				var styleAddComment = {
					'position': 'relative',
					'padding': '10px'
				};

				if(this.state.tagError) {
					var errorText = React.createElement("span", {className: "errorText"}, "Invalid Tag")
					var errorStyle = {
						border : "1px solid #f00"
					}
				}

				if(window.appData.local.suggestedTags) {
					var tagSuggestions = window.appData.local.suggestedTags.map(function(tag,index) {
						//return (<option key={tag.id} value={tag.tag}/>);c
						var click = function(e){
							window.appData.local.selectedTag = index;
							self.handleKeyPressTag({
								keyCode : 13,
								preventDefault : function(){}
							})
						};
						if(index == window.appData.local.selectedTag) {
							return (React.createElement("li", {onClick: click, className: "selected", key: tag.id, value: tag.data.tag}, tag.data.tag))
						} else {
							return (React.createElement("li", {onClick: click, key: tag.data.guid, value: tag.data.tag}, tag.data.tag))
						}
					});
				}

				if(tagSuggestions) {
					var suggestionList = (React.createElement("ul", {id: "suggestedTags"}, tagSuggestions));
				}

				var tagEditor = null;
				if(window.appData.user && window.appData.user.data.guid == window.appData.buncee.data.owner_guid) {
					tagEditor = (React.createElement("div", {style: styleAddComment}, 
						React.createElement("input", {ref: "tagInput", id: "input-tag", list: "suggests", style: errorStyle, type: "text", placeholder: "Enter Tags", onKeyUp: this.handleKeyPressTag, onBlur: this.clearTagSuggestions, onFocus: this.getTagSuggestions}), 
						React.createElement("span", {id: "submit-tag", onTouchEnd: this.postTag, onClick: this.postTag}, "POST"), 
						errorText, 
						suggestionList
					));
				}

				var all_comments = "";
				if(this.stores.buncee.getComments()) {
					all_comments = this.stores.buncee.getComments().map(function(comment){
						var classes = "wall-item-user-comment";
						if(window.appData.user && window.appData.user.data.guid == comment["owner_guid"]) {
							classes += " own";
						}
						var styleComment = {
							'background': "url('https://cdn.edu.buncee.com/rackspace/avatars/user_default.png')",
							'backgroundSize': '30px'
						};
						if(comment.avatar) {
							styleComment.background = "url("+comment.avatar+");"
						}

						return (
							React.createElement("span", {className: classes, cid: comment.guid, ref: "comment"+comment.guid}, 
								React.createElement("a", {href: "#", style: styleComment, className: "buncee-comment", "data-name": comment.first_name + " " + comment.last_name}
								), 
								React.createElement("div", null,  comment.body), 
								React.createElement("div", {className: "delete-comment icons8-delete-filled", "data-guid": comment.guid, onClick: self.deleteComment})
							)
						);
					})
				}
				

				var all_citations = "";
				var urls_cited = [];
				var all_tags = "";
				if(tags.length > 0) {
					if(window.appData.user && window.appData.user.data.guid == window.appData.buncee.data.owner_guid) {
						all_tags = tags.map(function(tag) {
							return (React.createElement("span", {className: "tag", "data-tagid": tag.guid, onTouchEnd: self.removeTag, onClick: self.removeTag}, tag.tag, React.createElement("span", {className: "buncee-tag-delete icons8-delete-filled"})));
						});
					}
					else {
						all_tags = tags.map(function(tag) {
							return (React.createElement("span", {className: "tag", "data-tagid": tag.guid}, tag.tag));
						});
					}
				}
				else {
					all_tags = (window.appData.user && window.appData.user.data.guid == window.appData.buncee.data.owner_guid) ? "You didn't add any tags yet." : "User didn't add any tags yet.";
				}

				if(this.state.hasCitations) {
					all_citations = this.stores.buncee.getBuncee().slides.map(function(slide){
						var citations = [];
						if(slide.background.attributes) {
							if(slide.background.attributes.source_url) {
								var classes = "wall-item-citation";
								var styleComment = {
									'background': "url("+slide.background.body+") 0% 0% / 100% 100% no-repeat",
									'backgroundSize': '30px'
								};
								if(urls_cited.indexOf(slide.background.body) == -1) {
									urls_cited.push(slide.background.body);
									citations.push(React.createElement("span", {className: classes}, 
														React.createElement("a", {href: "#", style: styleComment, className: "buncee-citation"}
														), 
														React.createElement("div", null, React.createElement("a", {
															href: slide.background.attributes.source_url}, slide.background.attributes.source_url)
														)
													));
								}
							}
						}
						citations.push(slide.items.map(function(item){
							if (item.content.attributes) {
								if (item.content.attributes.source_url) {
									var classes = "wall-item-citation";
									var styleComment = {
										'background': "url("+item.content.body+") 0% 0% / 100% 100% no-repeat",
										'backgroundSize': '30px'
									};
									if(urls_cited.indexOf(item.content.body) == -1) {
										urls_cited.push(item.content.body);
										return (React.createElement("span", {className: classes}, 
														React.createElement("a", {href: "#", style: styleComment, className: "buncee-citation"}
														), 
														React.createElement("div", null, React.createElement("a", {
															href: item.content.attributes.source_url}, item.content.attributes.source_url)
														)
													));
									}
								}
							}
						}));
						return citations;
					});
				}

				if(this.stores.buncee.getBuncee().commentable){
					/**
					 * TODO: Get actual comment count
					 */
					var commentButton = React.createElement("span", {className: "action icons8-comments", style: colorComment, onClick: this.toggleComment, "data-toggle": "tooltip", "data-placement": "bottom", title: "See the comments of this buncee"}, this.stores.buncee.getComments().length)
				}

				if(this.state.hasCitations) {
					var infoButton = React.createElement("span", {className: "action icons8-info", style: colorComment, onClick: this.toggleInfo, "data-toggle": "tooltip", "data-placement": "bottom", title: "Image Attributions"})
				}
				var tagButton = React.createElement("span", {className: "action icons8-tag", style: colorComment, onClick: this.toggleTags, "data-toggle": "tooltip", "data-placement": "bottom", title: "View Tags"})

				var bButton = null;
				if(window.opener) {
					bButton = React.createElement("div", {className: "header-button blue", onClick: this.closeBuncee, style: styleB}, "CLOSE");
				}
				else {
					styleB = {
						'marginLeft': '20px',
						'marginTop': '6px'
					};
					bButton = React.createElement("div", {className: "header-button blue", onClick: this.gotoBuncees, style: styleB, "data-toggle": "tooltip", "data-placement": "bottom", title: "Go to buncee home"}, React.createElement("img", {src: "https://cdn.edu.buncee.com/rackspace/shared/logo-emblem-256x215.png", height: "28"}));
				}

				//debugger;
				if(this.actions.getUserAgent().isMobileStrict()) {
					styleEdit = {
						'display':'none'
					}
				}

				/**
				 * TODO: Handle like and download permissions based on account type
				 * TODO: Get actual Like count
				 */
				var likeButton = null;
				var downloadButton = null;
				var editButton = null;
				var copyButton = null;
				var shareButton = null;
				var clipButton = null;
				var hamburgerButton = null;

				if (window.appData.hasOwnProperty("user") && window.api) {
					if(this.stores.buncee.getLikeState()) {
						likeButton = React.createElement("span", {className: "action icons8-like-filled", style: colorLike, onClick: this.likeBuncee, "data-toggle": "tooltip", "data-placement": "bottom", title: "Like this buncee"}, this.stores.buncee.getLikeCount());
					}
					else {
						likeButton = React.createElement("span", {className: "action icons8-like", style: colorLike, onClick: this.likeBuncee, "data-toggle": "tooltip", "data-placement": "bottom", title: "Like this buncee"}, this.stores.buncee.getLikeCount());	
					}
					if (self.hasPermission('creation.download.pdf')) {
						downloadButton = React.createElement("div", {className: "header-button blue download-button", style: styleExport, onClick: this.handleClickOnDownload}, "DOWNLOAD")
					}
					if (window.appData.user.data.guid == window.appData.buncee.data.owner_guid) {
						if(!appData.buncee.data.locked) {
							editButton = React.createElement("div", {className: "header-button yellow", style: styleEdit, onClick: this.handleClickOnEdit}, "EDIT");	
						} else {
							editButton = React.createElement("div", {className: "header-button grey", style: styleEdit, "data-toggle": "tooltip", "data-placement": "bottom", title: "This buncee cannot be edited because it has already been graded"}, "EDIT");
						}
						
					} else {
						if (window.appData.buncee.data.copyable) {
							copyButton = React.createElement("div", {className: "hidden-xs header-button yellow copy-button", style: styleSetting, onClick: this.handleClickOnCopy}, "COPY");
						}
					}
					shareButton = React.createElement("div", {className: "header-button yellow share-button", style: styleShare, onClick: this.handleClickOnShare}, "SHARE");

					clipButton = appData.buncee.data.copyable ? React.createElement("span", {className: "action icons8-cut-filled", style: colorClip, onClick: this.toggleClip, "data-toggle": "tooltip", "data-placement": "bottom", title: "Clip Slides"}) : null;
				}



				/**
				 * TODO: Handle permissions based on account type and ownership
				 */
				//if(bunceeInfo.owner.guid == window.config.userGUID){
				//	var editButton =
				//	var shareButton =
				//} else {
				//	// Public user
				//	if(bunceeInfo.copyable && window.config.userGUID){
				//		var copyButton =
				//	}
				//	tagEditor = null;
				//	tagIcon = null;
				//}

				var bunceeURL = window.appData.buncee.links.embed;
				var bunceePlayer = self.actions.getUserAgent().isBuggyIframe() ? React.createElement("embed", {id: "buncee-view", src: bunceeURL, width: "100%", allowFullScreen: true}) : React.createElement("iframe", {id: "buncee-view", src: bunceeURL, width: "100%", allowFullScreen: true});;
				var commentEditor = (React.createElement("div", {style: styleAddComment}, 
					React.createElement("input", {id: "input-comment", type: "text", placeholder: "Write your comment", onKeyPress: this.handleCommentEditorKeyPress}), 
					React.createElement("span", {id: "submit-comment", onTouchEnd: this.postComment, onClick: this.postComment}, "POST")
				));

				if(!window.appData.user) {
					commentEditor = null;
				}

				if(this.stores.buncee.getBuncee().privacy_level == "public") {
					shareButton =
						React.createElement("div", {className: "header-button yellow share-button", style: styleShare, onClick: this.handleClickOnShare}, "SHARE")
				}

				if(this.getUrlParameter('submission_guid') || this.getUrlParameter('assignment_guid')) {
					shareButton = null;
					editButton = null;
					likeButton = null;
					tagButton = null;
					clipButton = null;
					commentButton = null;
				}

				var clip_thumbnails = [];

				clip_thumbnails = _.map(appData.buncee.data.slides, function(slide, idx) {
					var isSelected = self.state.selectedToClip && _.contains(self.state.selectedToClip.slides, parseInt(idx));
					var classes = ["item-slide"];
					var innerMessage;

					if(isSelected) {
						classes.push("slide-selected");
						innerMessage = React.createElement("div", {className: "slide-clip-message"}, "Selected");
					}

					return (React.createElement("div", {className: classes.join(" ")}, React.createElement("div", {className: "item-slide-inner", onClick: self.toggleToClip}, React.createElement("img", {src: appData.buncee.data.thumbnails[idx]}), innerMessage)));
				});

				var clipActions = [];

				if(this.state.selectedToClip && this.state.selectedToClip.state == "clip") {
					clipActions.push(React.createElement("a", {className: "action-clip", onClick: this.postClips}, "Clip ", this.state.selectedToClip.slides.length, " slides!"));
				}

				clipActions.push(React.createElement("a", {className: "action-clip action-clip-close", onClick: this.toggleClip}, "Close"));

				var hamburgerButton = (
					React.createElement("div", {className: "header-button yellow mobile-dropdown-menu-button", style: styleShare}, 
						/*Spans for Animations*/React.createElement("span", null), React.createElement("span", null), React.createElement("span", null)
					)
				)

				if(this.state.orientation == 'portrait') {
					var leftColClasses = "col-xs-4 col-sm-4 col-md-3";
					var rightColClasses = "col-xs-8 col-sm-4 col-md-3 col-sm-push-4 col-md-push-6";
					var rightColDropdownClasses = "hidden";
					var titleClasses = "col-xs-12 col-sm-4 col-md-6 col-sm-pull-4 col-md-pull-3"
				} else {
					var leftColClasses = "col-xs-3 col-sm-4 col-md-3";
					var rightColClasses = "hidden-xs col-xs-3 col-sm-4 col-md-3 col-xs-push-6 col-sm-push-4 col-md-push-6";
					var rightColDropdownClasses = "col-xs-3 col-xs-push-6 hidden-sm hidden-md hidden-lg mobile-dropdown-menu-wrapper"
					var titleClasses = "col-xs-6 col-sm-4 col-md-6 col-xs-pull-3 col-sm-pull-4 col-md-pull-3"
					var copyButtonRight = (copyButton !== null ? React.createElement("div", {className: "header-button yellow copy-button", style: styleSetting, onClick: this.handleClickOnCopy}, "COPY") : null);
				}

				return (
					React.createElement("div", {style: {height:'100%'}}, 
						React.createElement("div", {id: "viewbuncee-body"}, 
							React.createElement("div", {id: "viewbuncee-toolbar", className: "row"}, 
								React.createElement("div", {className: leftColClasses, style: columnLeft}, 
									bButton, 
									copyButton, 
									editButton
								), 
								React.createElement("div", {className: rightColClasses, style: columnRight}, 
									downloadButton, 
									shareButton
								), 
								React.createElement("div", {className: rightColDropdownClasses, style: columnRight}, 
									React.createElement("div", {className: "mobile-dropdown-menu"}, 
										downloadButton, 
										shareButton, 
										copyButtonRight
									), 
									hamburgerButton
								), 
								React.createElement("div", {className: titleClasses, style: columnNoPadding}, 
									React.createElement("div", {id: "info-container", style: styleTitle}, 
										React.createElement("span", {id: "viewbuncee-title", className: !this.stores.buncee.getBuncee().title ? "untitled" : null}, 
											 this.stores.buncee.getBuncee().title || "Untitled"
										), 
										React.createElement("span", {id: "viewbuncee-owner"}, " by",  
										React.createElement("span", {className: "user-firstname"}, " ", this.stores.buncee.getBuncee().owner.data.first_name)
										), 
										React.createElement("span", {className: "actions"}, 
											infoButton, 
											React.createElement("span", {
											className: "action icons8-visible", 
											"data-toggle": "tooltip", 
											"data-placement": "bottom", 
											title: "Views", 
											style: { "color": "#178FA5", "fontSize": "16px"}}, 
												 this.stores.buncee.getViews() 
											), 
											likeButton, 
											commentButton, 
											tagButton, 
											clipButton
										)
									)
								)
							), 
							bunceePlayer, 
							React.createElement("div", {id: "comment-view", style: styleCommentView}, 
								React.createElement("div", {className: "title"}, "Comments"), 
								React.createElement("div", {className: "info-comments"}, 
									all_comments
								), 
								commentEditor, 
								React.createElement("div", {className: "close-comment", onClick: this.toggleComment}, "CLOSE")
							), 
							React.createElement("div", {id: "info-view", style: styleInfoView}, 
								React.createElement("div", {className: "title"}, "Image Attributions"), 
								React.createElement("div", {className: "desc"}, "Sources for images in this buncee added from the web are listed below"), 
								React.createElement("div", {className: "info-info"}, 
									all_citations
								), 
								React.createElement("div", {className: "close-info", onClick: this.toggleInfo}, "CLOSE")
							), 
							React.createElement("div", {id: "tag-view", style: styleTagView}, 
								React.createElement("div", {className: "title"}, "Tag"), 
								tagEditor, 
								React.createElement("div", {className: "tag-info"}, 
									all_tags
								), 
								React.createElement("div", {className: "close-tag", style: {"clear":"left"}, onClick: this.toggleTags}, "CLOSE")
							), 
							React.createElement("div", {id: "clip-view", style: styleClipView}, 
								React.createElement("div", {className: "clip-header"}, 
									React.createElement("div", {className: "title"}, "Clips"), 
									React.createElement("div", {className: "clip-selection-buttons"}, 
										React.createElement("a", {onClick: this.selectAllToClip}, "Select All"), 
										React.createElement("a", {onClick: this.deselectAllToClip}, "Unselect All")
									)
								), 
								React.createElement("div", {className: "all-slides"}, 
									clip_thumbnails
								), 
								React.createElement("div", {className: "clip-actions"}, 
									clipActions
								), 
								React.createElement("div", {className: "clip-pending-overlay", style: this.state.postingClips?{'display':'block'}:null}, 
									React.createElement("div", {className: "clip-pending-message"}, "Clipping...")
								)
							), 
							React.createElement("a", {id: "helpcenter", className: "hidden-xs", href: "https://app.edu.buncee.com/support", target: "_blank"}, 
								React.createElement("div", {className: "helpcenter-button -2"}), 
								React.createElement("div", {className: "helpcenter-text"}, "Need Help?"), 
								React.createElement("div", {className: "icons8-cancel helpcenter-close", onClick: this.closeHelpcenter})
							)
						)
					)
				);
			}
		});
	}
);
